import { Injectable } from '@angular/core';
import { PlatformService } from 'src/core/common/domain/platform/platform.service';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { SessionService } from 'src/core/session/domain/session.service';
import { ApiService } from 'src/core/api/domain/api.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private readonly platformService: PlatformService,
    private readonly firebaseX: FirebaseX,
    private readonly sessionService: SessionService,
    private readonly apiService: ApiService
  ) {}

  async logEvent(eventName: string, eventData: { [key: string]: any }) {
    const user = this.sessionService.getUser() ?? null;
    if (user) {
      eventData.user_id = user.id;
      eventData.user_email = user.email;
      eventData.user_full_name = user.fullName;
      eventData.user_username = user.username;
    }

    eventData.environment = this.apiService.currentApi().id;

    // console.log(eventName);
    // console.log(eventData);
    if (!this.platformService.isRealMobileDevice()) {
      return;
    }

    await this.firebaseX.logEvent(eventName, eventData);
  }
}
